var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef, useCallback } from "react";
export function useSafeTimeout() {
    var timeoutIds = useRef([]);
    useEffect(function () {
        return function () {
            timeoutIds.current.forEach(function (timeoutId) {
                clearTimeout(timeoutId);
            });
            timeoutIds.current = [];
        };
    }, []);
    var startTimeout = useCallback(function (callback, ms) {
        if (ms === void 0) { ms = 0; }
        var timeoutId = setTimeout(callback, ms);
        timeoutIds.current = __spreadArray(__spreadArray([], timeoutIds.current, true), [timeoutId], false);
        var cancelTimeout = function () {
            if (timeoutIds.current.includes(timeoutId)) {
                clearTimeout(timeoutId);
                timeoutIds.current = timeoutIds.current.filter(function (id) { return id !== timeoutId; });
            }
        };
        return cancelTimeout;
    }, []);
    return startTimeout;
}
